import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import FormSection from '../../../../components/FormComponents/FormSection';
import MainButton from '../../../../components/MUI/MainButton';
import PROPERTY_TYPES from '../../../../constants/propertyTypes';
import { LANGUAGES } from '../../../../constants';

import propertyIcon from '../../../../styles/svgs/property.svg';
import styles from '../../../../components/ClaimFormComponents/ExistingContracts/styles.module.scss';

const PropertyList = (props) => {
  const { realEstates, properties, onSelect, selected, icon, errors } = props;
  const { i18n, t } = useTranslation();
  const lang = i18n.language.toUpperCase();

  return (
    <FormSection title="propertyClaim.personalData.propertyList" icon={icon}>
      <div className={styles.existingContracts}>

        {realEstates && realEstates.map((realEstate) => {
          const type = PROPERTY_TYPES[realEstate.realEstateTypeId] || {};
          const typeText = type[`name${lang}`] || '';
          const areaText = `${realEstate.realEstateArea} ${t('area.sqm')}`;

          const price = realEstate.sumInsured ? parseInt(realEstate?.sumInsured).toLocaleString() : '';
          const priceText = `${price} ${t('currency.AMD')}`;

          const isSelected = selected.includes(realEstate.propertyRealEstateId);

          return (
            <div key={realEstate.propertyRealEstateId} className={styles.contractData}>
              <div className={styles.leftBlock}>
                <div className={styles.contractLogo}>
                  <img src={propertyIcon} alt="Contract" />
                </div>
              </div>
              <div className={styles.rightBlock}>
                <div className={styles.contractDetails}>
                  <div className={styles.content}>
                    <p className={styles.label}>{typeText}</p>
                    <p className={styles.insurer}>{areaText}</p>
                  </div>
                  <div className={styles.content}>
                    <p className={styles.label}>{t('propertyClaim.personalData.sumInsured')}</p>
                    <p>{priceText}</p>
                  </div>
                </div>
                <div className={styles.buttonContainer}>
                  <MainButton
                    variant={
                      isSelected ? 'outlined'
                        : 'contained'
                    }
                    color="primary"
                    size="small"
                    onClick={() => onSelect(realEstate.propertyRealEstateId)}
                    disabled={isSelected && realEstates.length === 1}
                  >
                    {isSelected
                      ? t('claim.button.selected')
                      : t('claim.button.select')}
                  </MainButton>
                </div>
              </div>
            </div>
          );
        })}
        {properties && properties.map((property) => {
          let { propertyName } = property;
          if (lang !== LANGUAGES.HY) {
            propertyName = property[`propertyName${lang}`] || propertyName;
          }

          const price = property.sumInsured ? parseInt(property?.sumInsured).toLocaleString() : '';
          const priceText = `${price} ${t('currency.AMD')}`;

          const isSelected = selected.includes(property.propertyId);

          return (
            <div key={property.propertyId} className={styles.contractData}>
              <div className={styles.leftBlock}>
                <div className={styles.contractLogo}>
                  <img src={propertyIcon} alt="Contract" />
                </div>
              </div>
              <div className={styles.rightBlock}>
                <div className={styles.contractDetails}>
                  <div className={styles.content}>
                    <p className={styles.label}>{t('propertyClaim.personalData.property')}</p>
                    <p className={styles.insurer}>{propertyName}</p>
                  </div>
                  <div className={styles.content}>
                    <p className={styles.label}>{t('propertyClaim.personalData.sumInsured')}</p>
                    <p>{priceText}</p>
                  </div>
                </div>
                <div className={styles.buttonContainer}>
                  <MainButton
                    variant={
                      isSelected ? 'outlined'
                        : 'contained'
                    }
                    color="primary"
                    size="small"
                    onClick={() => onSelect(property.propertyId)}
                    disabled={isSelected && properties.length === 1}
                  >
                    {isSelected
                      ? t('claim.button.selected')
                      : t('claim.button.select')}
                  </MainButton>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {errors.selectedProperties && (
        <p className={styles.errorText}>{t(errors.selectedProperties.message)}</p>
      )}
    </FormSection>
  );
};

PropertyList.propTypes = {
  icon: PropTypes.node.isRequired,
  errors: PropTypes.shape({
    selectedProperties: PropTypes.shape({
      message: PropTypes.string,
    }),
  }),
  realEstates: PropTypes.arrayOf(
    PropTypes.shape({
      realEstateTypeId: PropTypes.string.isRequired,
      realEstateArea: PropTypes.string,
      sumInsured: PropTypes.string,
    }),
  ),
  properties: PropTypes.arrayOf(
    PropTypes.shape({
      propertyId: PropTypes.string.isRequired,
      propertyName: PropTypes.string,
      propertyNameEN: PropTypes.string,
      propertyNameRU: PropTypes.string,
      sumInsured: PropTypes.string,
    }),
  ),
  selected: PropTypes.arrayOf(PropTypes.string).isRequired,
  onSelect: PropTypes.func.isRequired,
};

PropertyList.defaultProps = {
  errors: {},
  realEstates: [],
  properties: [],
};

export default PropertyList;
